module.exports = __webpack_public_path__ + "static/img/btn.eab8fe32.webp";